import CryptoJS from "crypto-js";

const KEY = CryptoJS.enc.Utf8.parse(
  process.env.REACT_APP_ENCRYPTION_KEY as string
);

const IV = CryptoJS.enc.Utf8.parse(
  process.env.REACT_APP_ENCRYPTION_IV as string
);

export const encryptAES = (text: string): string => {
  const encrypted = CryptoJS.AES.encrypt(text, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
};
